import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicThreshold({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.5 12c.28 0 .5.22.5.5v.5a.5.5 0 01-.5.5h-11A.5.5 0 012 13v-.5c0-.28.22-.5.5-.5zm.02-9.5c.42 0 .75.34.75.75v3a.75.75 0 11-1.5 0v-1.2l-3.9 3.9a.5.5 0 01-.63.06l-.07-.05L5.52 6.3 2.91 8.93a.5.5 0 01-.71 0l-.35-.36a.5.5 0 010-.7l3.32-3.33c.2-.2.51-.2.7 0L8.53 7.2 11.72 4h-1.2a.75.75 0 01-.74-.65v-.1c0-.41.33-.75.74-.75z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicThreshold.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicThreshold.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicThreshold svgRef={ref} {...props} />);
export default ForwardRef;
